import { Component, inject, signal } from '@angular/core';
import { IWizardStepComponent } from '@mwe/models';
import { HeadlineService, UiComponentsModule } from '@mwe/ui/components';
import { TopPageComponent } from '@shared-ikp/layout/top-page/top-page.component';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass } from '@angular/common';
import { CustomerRegistrationService } from '../../../service/customer-registration/customer-registration.service';
import { CustomValidators } from '@shared-ikp/utils/validators';
import { Router } from '@angular/router';
import { ROUTE_HOME } from '../../../app.constants';

@Component({
  selector: 'ikp-berater-invite',
  templateUrl: './invite.component.html',
  standalone: true,
  providers: [HeadlineService],
  imports: [UiComponentsModule, TopPageComponent, ReactiveFormsModule, NgClass],
})
export class InviteComponent implements IWizardStepComponent {
  protected readonly router = inject(Router);
  protected readonly registrationService = inject(CustomerRegistrationService);
  protected readonly fb = inject(FormBuilder);
  protected readonly isInviteError = signal(false);

  protected inviteForm = this.fb.group({
    email: [
      '',
      {
        validators: [Validators.required, CustomValidators.emailValidator],
        asyncValidators: [this.registrationService.emailAlreadyInUse()],
        updateOn: 'blur',
      },
    ],
  });

  validate(): boolean {
    this.inviteForm.markAllAsTouched();
    return this.inviteForm.valid;
  }

  hasAllNeededData(): boolean {
    return true;
  }

  async submit(): Promise<void> {
    this.isInviteError.set(false);
    this.registrationService.setSelectedEmail(this.inviteForm.value.email);

    try {
      await this.registrationService.createCustomer();
    } catch (error) {
      this.isInviteError.set(true);
      console.error(error);
      return Promise.reject(error);
    }
  }

  isEmailInvalid(): boolean {
    const field = this.inviteForm.get('email');
    return !!field && field.invalid && (field.touched || field.dirty);
  }

  onInfoMessageCTAClicked(): void {
    this.isInviteError.set(false);
    this.router.navigate([ROUTE_HOME]);
  }

  protected getFormError(fieldName: string): string {
    const formKey = this.inviteForm.get(fieldName);
    return formKey.errors ? formKey.errors.translationKey : null;
  }
}
